export default {
    average: 'Average',
    override: 'Overwrite',
    perception: 'Our estimation',
    save: 'Save',

    confirm: {
        title: 'Change rating',
        notice: 'You thus overrule the evaluation by the evaluation panel.',
        confirm: 'Yes, continue'
    },

    deleteOverrideConfirm: {
        title: 'Delete overrides?',
        notice: 'Overridden evaluations will be deleted.',
        confirm: 'Yes, continue'
    },

    deleteOverride: {
        button: 'Remove overrides'
    },

    error: {
        min: 'Minimum value ({min}) not reached',
        max: 'Maximum value ({max}) exceeded',
        nonNullable: 'This value must not be empty'
    }
}
